import { h } from 'preact';

export function IconPlay({ width = 42, height = 33, fill = 'currentColor' }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 18 14"
      width={width}
      height={height}
      fill="none"
      class="icon-play"
    >
      <path
        d="M15.5987 6.2911L3.45577 0.110898C2.83667 -0.204202 2.06287 0.189698 2.06287 0.819798V13.1802C2.06287 13.8103 2.83667 14.2042 3.45577 13.8891L15.5987 7.7089C16.2178 7.3938 16.2178 6.6061 15.5987 6.2911Z"
        fill={fill}
      />
    </svg>
  );
}
